const GETCOMPETITIONS = 'GETCOMPETITIONS';


export default {
    GETCOMPETITIONS,
};